import styles from "../../styles/MainBox.module.css";
import Link from "next/link";
import Image, { StaticImageData } from "next/image";

type MainBoxProps = {
	title: string;
	picture: StaticImageData;
	img_url: string;
	body: string;
	largeScreen: boolean;
	btn_url?: string;
	btn_title?: string;
};

export default function MainBox({
	title,
	picture,
	body,
	largeScreen,
	btn_url,
	btn_title,
}: MainBoxProps) {
	return (
		<div
			className={styles.main}
			style={{ width: largeScreen ? "31%" : "98%" }}
		>
			<h3>{title}</h3>
			<div className={styles.image}>
				<Image src={picture} alt={`${title} image`} fill sizes="100vw" style={{ objectFit: "cover" }} />
			</div>
			<div>{body}</div>
			<div style={{ height: "100%" }} />
			{btn_url && (
				<div className={styles.button}>
					<Link href={btn_url}>
						{btn_title}
					</Link>
				</div>
			)}
		</div>
	);
}
